import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SeasonWorldLandingComponent } from './season-world-landing.component';

const routes: Routes = [
    {
        path: 'season-world-landing',
        component: SeasonWorldLandingComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class SeasonWorldLandingRoutingModule { }
